module.exports = __webpack_public_path__ + "static/media/poire.5b358eeb.svg";